"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ = require(".");
var _SearchFilter = require("../Components/filters/SearchFilter");
var _DateFilter = require("../Components/filters/DateFilter");
var _TimeFilter = require("../Components/filters/TimeFilter");
var _NumberFilter = require("../Components/filters/NumberFilter");
var _CurrencyFilter = require("../Components/filters/CurrencyFilter");
var _SearchableDropDownFilter = require("../Components/filters/SearchableDropDownFilter");
var _ykbUtils = require("ykb-utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // components
var TYPE_FORMAT_MAP = {
  DATE: 'DD-MM-YYYY',
  DATETIME: 'DD-MM-YYYY HH:mm:ss',
  JSONDATE: 'DD-MM-YYYY HH:mm:ss',
  TIMESTAMP: 'DD-MM-YYYY HH:mm:ss',
  TIME: 'HH:mm:ss'
};
function ibanSearchFilter(column, locale) {
  var autoFilterProps = Object.assign({}, column.autoFilterProps);
  column.filterDropdown = function (props) {
    return /*#__PURE__*/_react.default.createElement(_SearchFilter.SearchFilter, (0, _extends2.default)({}, props, {
      locale: locale
    }, autoFilterProps));
  };
  if (!column.onFilter) {
    column.onFilter = function (v, record) {
      return (0, _SearchFilter.onSearchFilter)(column.dataIndex, v, record);
    };
  }
}
function dateFilter(column, locale) {
  var autoFilterProps = Object.assign({}, column.autoFilterProps);
  var format = column.format ? column.format : TYPE_FORMAT_MAP[column.type.toUpperCase()];
  column.filterDropdown = function (props) {
    return /*#__PURE__*/_react.default.createElement(_DateFilter.DateFilter, (0, _extends2.default)({}, props, {
      locale: locale,
      format: format
    }, autoFilterProps));
  };
  if (!column.onFilter) {
    column.onFilter = function (v, record) {
      return (0, _DateFilter.onDateFilter)(column.dataIndex, v, record, format);
    };
  }
}
function timeFilter(column, locale) {
  var autoFilterProps = Object.assign({}, column.autoFilterProps);
  var format = TYPE_FORMAT_MAP[column.type.toUpperCase()];
  column.filterDropdown = function (props) {
    return /*#__PURE__*/_react.default.createElement(_TimeFilter.TimeFilter, (0, _extends2.default)({}, props, {
      locale: locale,
      format: format
    }, autoFilterProps));
  };
  if (!column.onFilter) {
    column.onFilter = function (v, record) {
      return (0, _TimeFilter.onTimeFilter)(column.dataIndex, v, record, format);
    };
  }
}
function numberFilter(column, locale) {
  var autoFilterProps = Object.assign({}, column.autoFilterProps);
  column.filterDropdown = function (props) {
    return /*#__PURE__*/_react.default.createElement(_NumberFilter.NumberFilter, (0, _extends2.default)({
      dataIndex: column.dataIndex
    }, props, {
      locale: locale
    }, autoFilterProps));
  };
  if (!column.onFilter) {
    column.onFilter = function (v, record) {
      return (0, _NumberFilter.onNumberFilter)(column.dataIndex, v, record);
    };
  }
}
function currencyFilter(column, locale) {
  var autoFilterProps = Object.assign({}, column.autoFilterProps);
  column.filterDropdown = function (props) {
    return /*#__PURE__*/_react.default.createElement(_CurrencyFilter.CurrencyFilter, (0, _extends2.default)({
      dataIndex: column.dataIndex,
      currencyType: column.currencyType,
      currencyPrecision: column.currencyPrecision
    }, props, {
      locale: locale
    }, autoFilterProps));
  };
  if (!column.onFilter) {
    column.onFilter = function (v, record) {
      return (0, _CurrencyFilter.onCurrencyFilter)(column.dataIndex, v, record);
    };
  }
}
function searchableFilter(column, locale) {
  var autoFilterProps = Object.assign({}, column.autoFilterProps);
  column.filterDropdown = function (props) {
    return /*#__PURE__*/_react.default.createElement(_SearchableDropDownFilter.SearchableDropDown, (0, _extends2.default)({}, props, {
      filters: column.filters,
      multiple: !!column.multiple,
      dataIndex: column.dataIndex,
      locale: locale
    }, autoFilterProps));
  };
  if (!column.onFilter) {
    column.onFilter = function (v, record) {
      return (0, _SearchableDropDownFilter.onDropDownFilter)(column.dataIndex, v, record);
    };
  }
}
function checkColumnFilters(columnData, locale) {
  var column = _.Utils.splitDataIndex(_objectSpread({}, columnData));
  if ((0, _ykbUtils.isNullOrUndefined)(column)) return column;
  if (column.autoFilter) {
    var type = _.Utils.getFilterType(column);
    var filters = {
      ibanSearchFilter: ibanSearchFilter,
      dateFilter: dateFilter,
      timeFilter: timeFilter,
      numberFilter: numberFilter,
      currencyFilter: currencyFilter,
      searchableFilter: searchableFilter
    };
    if (filters[type]) filters[type](column, locale);
  }
  return column;
}
var _default = exports.default = {
  checkColumnFilters: checkColumnFilters
};